var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["USER_PERSONA_ERROR_TYPE_SC_001_4207"] = "UserPersonaErrorType_SC-001-4207";
    ErrorCodes["IMAGE_ERROR_SC_001_6801"] = "ImageError_SC-001-6801";
    ErrorCodes["USER_PERSONA_ERROR_TYPE_SC_001_4208"] = "UserPersonaErrorType_SC-001-4208";
    ErrorCodes["IMAGE_ERROR_SC_001_6802"] = "ImageError_SC-001-6802";
    ErrorCodes["CHARACTER_ERROR_SC_001_1215"] = "CharacterError_SC-001-1215";
    ErrorCodes["CHARACTER_ERROR_SC_001_1213"] = "CharacterError_SC-001-1213";
    ErrorCodes["CHARACTER_ERROR_SC_001_1214"] = "CharacterError_SC-001-1214";
    ErrorCodes["CHARACTER_ERROR_SC_001_1212"] = "CharacterError_SC-001-1212";
    ErrorCodes["CHARACTER_ERROR_SC_001_1203"] = "CharacterError_SC-001-1203";
})(ErrorCodes || (ErrorCodes = {}));
export { ErrorCodes };
